var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4978_62682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.67 39V27.39H33.5583L34.14 22.8767H29.67V19.9967C29.67 18.69 30.0333 17.7983 31.9067 17.7983H34.2967V13.7617C33.1397 13.6389 31.9768 13.5794 30.8133 13.5833C27.3683 13.5833 25.01 15.6867 25.01 19.55V22.8767H21.1133V27.39H25.01V39H10.6667C10.2246 39 9.80072 38.8244 9.48816 38.5118C9.17559 38.1993 9 37.7754 9 37.3333V10.6667C9 10.2246 9.17559 9.80072 9.48816 9.48816C9.80072 9.17559 10.2246 9 10.6667 9H37.3333C37.7754 9 38.1993 9.17559 38.5118 9.48816C38.8244 9.80072 39 10.2246 39 10.6667V37.3333C39 37.7754 38.8244 38.1993 38.5118 38.5118C38.1993 38.8244 37.7754 39 37.3333 39H29.67Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4978_62682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0caf2c8e0344f1a31110bba166fb342d.svg";
export { ForwardRef as ReactComponent };